import { render, staticRenderFns } from "./CardApvaStep.vue?vue&type=template&id=27dcb04e&"
import script from "./CardApvaStep.vue?vue&type=script&lang=js&"
export * from "./CardApvaStep.vue?vue&type=script&lang=js&"
import style0 from "./CardApvaStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports